import { render, staticRenderFns } from "./CaptchaFormRow.vue?vue&type=template&id=63c0509a"
import script from "./CaptchaFormRow.vue?vue&type=script&lang=js"
export * from "./CaptchaFormRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports